import moment from "moment";
import React from "react";
export const ScheduleStatus = ({ status }: any) => {
  if (status == "on") {
    return <span className="badge badge-warning">Delayed</span>;
  }
  if (status == "To Be Processed" || status == "Unmarked") {
    return <span className="badge badge-aeslProofread">Unmarked</span>;
  }
  if (status == "On Track" || status == "Marked") {
    return <span className="badge badge-success">Marked</span>;
  }
  if (status == "upcoming" || status == "Upcoming") {
    return <span className="badge badge-Upcoming">Upcoming</span>;
  }
  if (status == "Ongoing") {
    return <span className="badge badge-aeslPublish">Ongoing</span>;
  }
  if (status == "delayed" || status == "Delayed") {
    return <span className="badge badge-aeslReview">Delayed</span>;
  }
  return <span className="badge badge-aeslDraft">{status}</span>;
};
export const AttendanceStatus = ({ status }: any) => {
  if (status == "on") {
    return <span className="badge badge-warning">Delayed</span>;
  }
  if (status == null || status == "Unmarked") {
    return <span className="badge badge-aeslProofread">Not Taken</span>;
  }
  if (status == "On Track" || status == "Marked") {
    return <span className="badge badge-success">Taken</span>;
  }
  return <span className="badge badge-aeslDraft">{status}</span>;
};
export const ScheduleStatusColor = (status: any) => {
  if (status == "on") {
    return "green";
  } else if (
    status == "To Be Processed" ||
    status == "Not Marked" ||
    status == "Unmarked"
  ) {
    return "#D29822";
  } else if (status == "Marked") {
    return "#05945B";
  } else if (status == "upcoming" || status == "Upcoming") {
    return "#572AC8";
  } else if (status == "Ongoing") {
    return "#008DC4";
  } else if (status == "delayed" || status == "Delayed") {
    return "#F9D9D7";
  } else return "gray";
};
export function inBetweenTime(startTime: any, endTime: any) {
  let isBetween = false;
  const time = moment(new Date().toUTCString());
  const beforeTime = moment(startTime);
  const afterTime = moment(endTime);
  if (time.isBetween(beforeTime, afterTime)) {
    isBetween = true;
  } else {
    isBetween = false;
  }
  return isBetween;
}
